import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import api from '../config/api';
import { Button, Dialog, Spinner } from '../ui';
import { RefreshIcon } from '../ui/icons';

const RETRY_MS = 10000;

/**
 * 'maintenance': a full page while a release is under way; it asks the server
 * every 10 s and reloads once it answers (the new bundle may be there).
 * 'client_outdated': this bundle predates the server; a reload fetches the new one.
 */
function ServiceNotice({ kind }) {
  const { t } = useTranslation();

  useEffect(() => {
    if (kind !== 'maintenance') return undefined;
    const timer = setInterval(async () => {
      try {
        await api.get('/auth/me');
        window.location.reload();
      } catch (error) {
        if (error.response?.data?.code !== 'maintenance') window.location.reload();
      }
    }, RETRY_MS);
    return () => clearInterval(timer);
  }, [kind]);

  if (kind === 'maintenance') {
    return (
      <main className="service-page" role="status">
        <Spinner size={28} />
        <h1 className="service-page__title">{t('service.maintenance')}</h1>
        <p className="settings-muted">{t('service.retrying')}</p>
      </main>
    );
  }
  return (
    <Dialog open role="alertdialog" title={t('service.outdated')} size="sm"
            footer={<Button icon={RefreshIcon} onClick={() => window.location.reload()}>{t('service.reload')}</Button>} />
  );
}

export default ServiceNotice;
